var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowNorthEast(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99973 6C8.99973 6.56 9.44973 7 9.99973 7H15.5897L4.69973 17.89C4.30973 18.28 4.30973 18.91 4.69973 19.3C5.08973 19.69 5.71973 19.69 6.10973 19.3L16.9997 8.41V14C16.9997 14.55 17.4497 15 17.9997 15C18.5497 15 18.9997 14.55 18.9997 14V6C18.9997 5.45 18.5497 5 17.9997 5H9.99973C9.44973 5 8.99973 5.45 8.99973 6Z",
    fill: "#1A1A1A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNorthEast);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguOTk5NzMgNkM4Ljk5OTczIDYuNTYgOS40NDk3MyA3IDkuOTk5NzMgN0gxNS41ODk3TDQuNjk5NzMgMTcuODlDNC4zMDk3MyAxOC4yOCA0LjMwOTczIDE4LjkxIDQuNjk5NzMgMTkuM0M1LjA4OTczIDE5LjY5IDUuNzE5NzMgMTkuNjkgNi4xMDk3MyAxOS4zTDE2Ljk5OTcgOC40MVYxNEMxNi45OTk3IDE0LjU1IDE3LjQ0OTcgMTUgMTcuOTk5NyAxNUMxOC41NDk3IDE1IDE4Ljk5OTcgMTQuNTUgMTguOTk5NyAxNFY2QzE4Ljk5OTcgNS40NSAxOC41NDk3IDUgMTcuOTk5NyA1SDkuOTk5NzNDOS40NDk3MyA1IDguOTk5NzMgNS40NSA4Ljk5OTczIDZaIiBmaWxsPSIjMUExQTFBIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };